import React, { Component } from 'react';
// import './ScoreCard.css';
import { Accordion, Card, Button, Form, Col, Image } from 'react-bootstrap';
import EndpointConstant from './../../constants/EndpointConstant';
import utils from './../../utils';
import PropTypes from 'prop-types';
import RoleConstant from '../../constants/RoleConstant';
import { MultiSelect } from 'react-multi-select-component';
class ScorecardQuestionariesSearch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            questionName: [],
            createdBy: '',
            iconName: 'icon-drop-up',
            selectedQuestion: [],
            selectedNames: []
        }
        this.iconChange = this.iconChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleOnClear = this.handleOnClear.bind(this);
       
    }

    iconChange() {
        if (this.state.iconName === 'icon-drop-up') {
            this.setState({ iconName: 'icon-drop-down' })
        } else {
            this.setState({ iconName: 'icon-drop-up' })
        }
    }

    handleOnChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleOnClear() { 
        this.setState({
            selectedQuestion: [],
            selectedNames: []
        });
        this.searchResults({})
    }

    handleSearch(event) {
        event.preventDefault();
        let data = {};
        if(this.state.selectedQuestion.length) {
            data.questionsetName = this.state.selectedQuestion;
        }
        if(this.state.selectedNames.length) {
            data.createdBy = this.state.selectedNames;
        }
       this.searchResults(data)
    }

    searchResults(data) {
        let self = this;
        utils.makeRequest(this, EndpointConstant.SCORECARD_QUESTIONARIE_LIST, data, function (result) {
          utils.hideLoader();
            if (result.error === false) {
            self.loading = false;
            self.props.searchResult(result.Questionaries)
          }
        })
    }

    customFilter = (options, filter) => {
        if(!filter) return options;

    const search = filter.toLowerCase();

    return options.filter(option => 
      option.label.toLowerCase().includes(search)
    )
    .sort((a, b) => {
      const aLabel = a.label.toLowerCase();
      const bLabel = b.label.toLowerCase();

      const aStarts = aLabel.startsWith(search);
      const bStarts = bLabel.startsWith(search);

      if (aStarts && !bStarts) return -1;
      if (!aStarts && bStarts) return 1;
      return 0;
    });
      };

    render() {
        const questionList = [];
        const createdByList = [];
       this.props.questionDetails.forEach(val => {
        questionList.push({label: val.questionsetName, value: val.id});
        if(!createdByList.some(values => values.value === val.createdBy)) {
            createdByList.push({label: val.createdByName, value: val.createdBy})
        }       
       });
      

        return (
            <Accordion defaultActiveKey="0" className='cardPadding'>
                <Card >
                    <Accordion.Toggle as={Card.Header} eventKey="0" onClick={this.iconChange} className='cardBodyStyle'>
                        <span className="search-title">SEARCH SCORE CARD QUESTIONNAIRES</span><Image src="/Images/ico-drop-up.png" className={this.state.iconName}></Image>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body className='cardBodyStyle'>
                            <Form onSubmit={this.handleSearch}>
                                <Form.Row className='mb-2'>
                                    <Form.Group as={Col} md="3" controlId="name">
                                        <Form.Label className='lable-names'>Questionset</Form.Label>
                                        <MultiSelect
                                            options={questionList}
                                            value={questionList.filter(option =>
                                                this.state.selectedQuestion.includes(option.value)
                                            )}
                                            disableSearch={false}
                                            hasSelectAll={true}
                                            filterOptions={this.customFilter}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions
                                                    ? selectedOptions.map(item => item.value)
                                                    : [];

                                                this.setState({
                                                    selectedQuestion: selectedValues,
                                                });
                                            }}
                                            ClearSelectedIcon={null}
                                            valueRenderer={(selected) => {
                                                if (!selected.length) {
                                                    return "--Select--";
                                                }

                                                if (selected.length === questionList.length) {
                                                    return "All are Selected";
                                                }

                                                return selected.map(option => option.label).join(", ");
                                            }}
                                            labelledBy="--Select--"
                                            overrideStrings={{
                                                selectSomeItems: "--Select--",
                                                allItemsAreSelected: "All are Selected",
                                                selectAll: "Select All",
                                            }}
                                            className='scorecard-questionaries-search'
                                        />                                       
                                    </Form.Group>
                                    <Form.Group as={Col} md="3" controlId="createdBy">
                                        <Form.Label className='lable-names'>Created By</Form.Label>
                                        <MultiSelect
                                            options={createdByList}
                                            value={createdByList.filter(option =>
                                                this.state.selectedNames.includes(option.value)
                                            )}
                                            disableSearch={false}
                                            hasSelectAll={true}
                                            filterOptions={this.customFilter}
                                            onChange={(selectedOptions) => {
                                                const selectedValues = selectedOptions
                                                    ? selectedOptions.map(item => item.value)
                                                    : [];

                                                this.setState({
                                                    selectedNames: selectedValues,
                                                });
                                            }}
                                            ClearSelectedIcon={null}
                                            valueRenderer={(selected) => {
                                                if (!selected.length) {
                                                    return "--Select--";
                                                }

                                                if (selected.length === createdByList.length) {
                                                    return "All are Selected";
                                                }

                                                return selected.map(option => option.label).join(", ");
                                            }}
                                            labelledBy="--Select--"
                                            overrideStrings={{
                                                selectSomeItems: "--Select--",
                                                allItemsAreSelected: "All are Selected",
                                                selectAll: "Select All",
                                            }}
                                            className='scorecard-questionaries-search'
                                        />                                        
                                    </Form.Group>
                                    <Form.Group as={Col} md="1.5" controlId="search">

                                        <Button variant="secondary" type="submit" className='scorecardQueSearch button-color '>Search</Button>

                                    </Form.Group>
                                    <Form.Group as={Col} md="1" controlId="clear">
                                        <Button variant="secondary" className='scorecardQueSearch clear' onClick={this.handleOnClear}>Clear</Button>
                                    </Form.Group>
                                </Form.Row>
                                {/* <Button variant="secondary" type="submit" className='scorecardSearch button-color '>Search</Button>
                                <Button variant="secondary" className='clear' onClick={this.handleOnClear}>Clear</Button> */}
                            </Form>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            </Accordion>
        )
    }
}

ScorecardQuestionariesSearch.propTypes = {
    searchResult: PropTypes.func,
    questionDetails: PropTypes.array
}

export default ScorecardQuestionariesSearch;
